import * as React from "react";
import { Link } from "react-router-dom";

import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { ProjectContext, ProjectType } from "@/context/project";

export const ProjectNotFound = () => {
  const { projectsMap } = React.useContext(ProjectContext);
  const projects: ProjectType[] = Object.values(projectsMap);
  return (
    <main className="flex h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="text-3xl font-bold tracking-tight">Project Not Found</h1>
      <p className="max-w-md text-muted-foreground">
        The project you are looking for either does not exist or you do not have
        permission to access it. Please check the project ID or contact support.
      </p>
      {projects.length > 0 && (
        <div className="mt-8 w-full max-w-4xl">
          <h2 className="mb-4 text-2xl font-semibold">
            Or select from your available projects
          </h2>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {projects.map((project: ProjectType) => (
              <Link
                to={`/projects/${project.id}`}
                key={project.id}
                className="block"
              >
                <Card className="h-full text-left transition-all hover:border-primary hover:shadow-lg">
                  <CardHeader>
                    <CardTitle>{project.name}</CardTitle>
                    <CardDescription>{project.domainName}</CardDescription>
                  </CardHeader>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      )}
    </main>
  );
};
